<template>
  <div id="home">
    <Hero />
    <About />
    <Ingredients />
    <Counter />
    <Gallery />
    <ContactForm />
  </div>
</template>

<script>
import Hero from "./Hero.vue";
import About from "./About.vue";
import Counter from "./Counter.vue";
import Ingredients from "./Ingredients.vue";
import ContactForm from "./ContactForm.vue";
import Gallery from "./Gallery.vue";

export default {
  name: "Home",
  components: {
    Hero,
    About,
    Counter,
    Ingredients,
    ContactForm,
    Gallery,
  }
};
</script>

<style>
</style>
